import { render, staticRenderFns } from "./AssetDeArchive.vue?vue&type=template&id=66cc791c"
import script from "./AssetDeArchive.vue?vue&type=script&lang=js"
export * from "./AssetDeArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports